import * as React from "react";
import { Box } from "grid-styled";
import { Redirect, Route, Switch } from "react-router-dom";
import queryString from "query-string";
import { gql } from "apollo-boost";
import { graphql } from "react-apollo";
import UnderConstruction from "../UnderConstruction";
import Jobs from "../Jobs";
import Job from "../Job";
import Reports from "./Reports";
import DailySalesReport from "../reports/DailySalesReport";
import SalesBySalespersonReport from "../reports/SalesBySalespersonReport";
import MonthlySalesReport from "../reports/MonthlySalesReport";
import NewJob from "../NewJob";
import join from "../../utils/join-path";
import FranchiseStaff from "../FranchiseStaff";
import CenteredLoader from "../CenteredLoader";
import SearchResults from "../SearchResults";
import NotFound from "../NotFound";

const FranchiseRoutes = ({
  match,
  data: { loading, franchiseBySlug: franchise }
}) => {
  if (loading && !franchise) return <CenteredLoader />;
  if (!franchise) return <NotFound />;

  return (
    <Switch>
      <Redirect exact path={match.path} to={join(match.url, "/jobs")} />
      <Route path={`${match.path}/dashboard`} component={UnderConstruction} />
      <Route
        path={`${match.path}/search`}
        render={({ match, location }) => {
          const query = queryString.parse(location.search);
          return (
            <Box p={3}>
              <SearchResults
                match={match}
                franchiseId={franchise.id}
                q={query.q}
              />
            </Box>
          );
        }}
      />
      <Route
        path={`${match.path}/jobs`}
        exact
        render={props => <Jobs {...props} franchiseId={franchise.id} />}
      />
      <Route
        path={`${match.path}/jobs/new`}
        render={props => <NewJob {...props} franchise={franchise} />}
      />
      <Route path={`${match.path}/jobs/:jobId`} component={Job} />
      <Route path={`${match.path}/reports`} exact component={Reports} />
      <Route
        path={`${match.path}/reports/daily-sales`}
        render={props => <DailySalesReport franchiseId={franchise.id} />}
      />
      <Route
        path={`${match.path}/reports/monthly-sales-by-franchise`}
        render={props => <MonthlySalesReport franchiseId={franchise.id} />}
      />
      <Route
        path={`${match.path}/reports/sales-by-salesperson`}
        render={props => (
          <SalesBySalespersonReport franchiseId={franchise.id} />
        )}
      />
      <Route
        path={`${match.path}/staff`}
        render={({ match }) => (
          <Box px={3}>
            <FranchiseStaff franchiseId={franchise.id} />
          </Box>
        )}
      />
    </Switch>
  );
};

const FranchiseQuery = gql`
  query FranchiseSlugQuery($slug: String!) {
    franchiseBySlug(slug: $slug) {
      id
      name
      slug
    }
  }
`;

export default graphql(FranchiseQuery, {
  options: ({ match: { params: { franchiseSlug } } }) => ({
    variables: { slug: franchiseSlug }
  })
})(FranchiseRoutes);



// WEBPACK FOOTER //
// ./src/components/franchise/Routes.js